// extracted by mini-css-extract-plugin
export default {"chartTable":"PrintChart_chartTable__AzsAp"};